























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import UploadOSS from '@/components/upload/index.vue'
import AlbumsApi from '@/api/albums/list'

@Component({
  components: {
    UploadOSS
  }
})
export default class PicModal extends Vue {
  @Prop({ type: String, default: '选择图片' })
  title: string
  // 可选数量 -1表示不限制
  @Prop({ type: Number, default: 6 })
  selectNumber: number
  @Prop({ type: String, default: '选择图片' })
  buttonText: string
  // 是否显示图片样式
  @Prop({ type: Boolean, default: false })
  isShowImg: boolean
  // 是否使用行内样式
  @Prop({ type: Boolean, default: true })
  inline: boolean

  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: true
  })
  showBtn!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  show!: boolean

  @Watch('show')
  showChange(show) {
    this.showModal = !this.showModal
    this.getAlbumsList()
  }

  showModal = false
  page = {
    totalCount: 0,
    currentPage: 1,
    skipCount: 0,
    maxResultCount: 40
  }
  albumsList = []
  albumsActiveId = -1
  imgList = []
  selectImgList = []
  albumsActiveName = null
  isShowAlbumsActiveName = false // 是否显示添加相册子内容

  get dir() {
    return 'images/' + this.albumsActiveId
  }

  created() {}

  showFn() {
    this.showModal = true
    this.$emit('handleClickSelecImg')
    this.getAlbumsList()
  }

  /**
   * 获取相册列表
   */
  getAlbumsList() {
    AlbumsApi.getAlbumsList(999, 0).then(res => {
      if (res.data) {
        this.albumsList = res.data.items || []
        if (this.albumsList.length > 0) {
          this.albumsActiveId =
            this.albumsActiveId <= 0
              ? this.albumsList[0].id
              : this.albumsActiveId
        }
        this.getImagesList()
      }
    })
  }

  /**
   * 取消创建相册
   */
  cancelAlbumsActiveFn() {
    this.isShowAlbumsActiveName = false
    this.albumsActiveName = null
  }

  /**
   * 创建相册
   */
  createAlbumsActiveFn() {
    if (!this.albumsActiveName) {
      this.$Notice.warning({
        title: '请输入相册名'
      })
      return
    }

    AlbumsApi.createAlbums(this.albumsActiveName)
      .then(res => {
        this.cancelAlbumsActiveFn()
        this.getAlbumsList()
      })
      .catch(err => {
        this.$Notice.error({ title: '创建失败，请稍后再试' })
      })
  }

  /**
   * 获取图片列表
   */
  getImagesList() {
    if (this.albumsActiveId && this.albumsActiveId != -1) {
      let { maxResultCount, currentPage } = this.page
      AlbumsApi.getImagesList(
        this.albumsActiveId,
        maxResultCount,
        currentPage
      ).then(res => {
        if (res.data) {
          // console.log('图片列表', res.data);
          res.data.items.forEach(item => {
            item['active'] = false
            this.selectImgList.forEach(child => {
              if (item.id == child.id) {
                item['active'] = true
              }
            })
          })
          this.imgList = res.data.items || []
          this.page.totalCount = res.data.totalCount
        }
      })
    }
  }

  /**
   * 选择相册
   */
  selectAlbumsFn(item) {
    if (this.albumsActiveId != item.id) {
      this.albumsActiveId = item.id
      this.imgList = []
      this.page = {
        totalCount: 0,
        currentPage: 1,
        skipCount: 0,
        maxResultCount: 40
      }
      this.getImagesList()
    }
  }

  /**
   * 选择图片
   */
  selectImgFn(params) {
    let vm = this
    let isHave = vm.selectImgList.some(item => item.id == params.id)

    if (
      !isHave &&
      (vm.selectNumber == -1 || vm.selectImgList.length < vm.selectNumber)
    ) {
      params['active'] = true
      vm.selectImgList.push(params)
    } else {
      // 增加只选一张的时候的判断
      if (vm.selectNumber === 1) {
        vm.imgList.forEach(item => (item['active'] = false))
        params['active'] = true
        vm.selectImgList = [params]
      } else {
        params['active'] = false
        vm.selectImgList.forEach((item, index) => {
          if (item.id == params.id) {
            vm.selectImgList.splice(index, 1)
          }
        })
      }
    }
  }

  /**
   * 给相册添加图片
   */
  uploadChange(event) {
    AlbumsApi.createImg(this.albumsActiveId, event).then(res => {
      this.getImagesList()
    })
  }

  /**
   * 清除所选
   */
  clearFn() {
    let vm = this
    vm.selectImgList = []
    vm.imgList.forEach(item => (item['active'] = false))
  }

  cancelFn() {
    this.page = {
      totalCount: 0,
      currentPage: 1,
      skipCount: 0,
      maxResultCount: 40
    }
    this.albumsList = []
    this.albumsActiveId = -1
    this.imgList = []
    this.selectImgList = []
    this.albumsActiveName = null
    this.isShowAlbumsActiveName = false // 是否显示添加相册子内容
  }

  confirmFn() {
    let list = this.selectImgList
    if (list.length > 0) {
      this.$emit('picChange', list)
    }
    this.cancelFn()
  }

  changePage(e) {
    this.page.currentPage = e
    this.page.skipCount =
      this.page.currentPage <= 1
        ? 0
        : (this.page.currentPage - 1) * this.page.maxResultCount
    this.imgList = []
    this.getImagesList()
  }
  pageSizeChange(e) {
    this.imgList = []
    this.page.maxResultCount = e
    this.getImagesList()
  }
}
